import { css } from '@emotion/css'

export { BackendSystemItem } from './backend-system-item'
export { EmptyStateColumn } from './empty-state-column'
export { ApplicationFlowMap, FlowMapManager } from './application-flow-map'
export { FlowMapLoader } from './flow-map-loader'
export { ApplicationPreviewCard } from './application-preview-card'
export { ApplicationArchitectureCard } from './application-architecture-card'
export { WrappedBrowserBar } from './wrapped-browser-bar'
export { WrappedLastAgentUpdate } from './wrapped-last-agent-update-label'

export type ApplicationArchitectureComponentType = 'db' | 'ws' | 'ldap'
export type EncryptionStatusType = 'ENCRYPTED' | 'UNENCRYPTED' | 'UNKNOWN'
export type ApplicationLayerType = 'view' | 'presentation' | 'service'
export type FlowmapColumnType = 'COMPONENTS' | 'CONNECTED_APPS'

export type AppAggregationCategory =
  | 'servers'
  | 'languages'
  | 'technologies'
  | 'tags'
  | 'environments'

export const architectureColumnMinHeight = 350

export const architectureColumnWidth = 700
export const componentsColumnWidth = 350
export const connectedAppsColumnWidth = 425

export const columnMarginTop = 11

export const getColumnContainerStyle = (
  width: number,
  marginTop?: number
) => css`
  width: ${width}px;
  max-width: ${width}px;
  flex-direction: column;
  margin-top: ${marginTop}px;

  justify-content: center;
  display: flex;

  height: fit-content;
`

export const diagramHeight = 2000
